module.exports = __webpack_public_path__ + "static/img/two.78b03e6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/index/two.jpeg
// module id = 296N
// module chunks = 202